import api from '../../utils/api'

export const state = {
  suggestionsImprovements: [],
  suggestionsImprovementsMeta: []
}

export const mutations = {
  SET_SUGGESTIONS_IMPROVEMENTS(state, suggestionsImprovements) {
    state.suggestionsImprovements = suggestionsImprovements
  },
  SET_SUGGESTIONS_IMPROVEMENTS_META(state, suggestionsImprovementsMeta) {
    state.suggestionsImprovementsMeta = suggestionsImprovementsMeta
  }
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/suggested-improvement', body)
    } catch (err) {

    }
  },
  async handlePaginatedList({ commit }, payload) {
    let params = {}
    if (payload) {
      params = {
        endDate: payload.endDate || null,
        startDate: payload.startDate || null,
        search: payload.search || null,
        skip: payload.skip || 0,
        limit: payload.limit || 10
      }
    }
    const { data: response } = await api.get(`/suggested-improvement`, { params })
    console.log(response)
    if (response && response.items) {
      commit('SET_SUGGESTIONS_IMPROVEMENTS', response.items)
      commit('SET_SUGGESTIONS_IMPROVEMENTS_META', response.meta)
    } else {
      commit('SET_SUGGESTIONS_IMPROVEMENTS', [])
      commit('SET_SUGGESTIONS_IMPROVEMENTS_META', {})
    }
  },
  handleResetMeta: ({ commit }) => commit('SET_SUGGESTIONS_IMPROVEMENTS_META', {
    startDate: null,
    endDate: null,
    search: null,
    limit: 10,
    skip: 0,
  })
}

export const getters = {
  suggestionsImprovements: (state) => state.suggestionsImprovements,
  suggestionsImprovementsMeta: (state) => state.suggestionsImprovementsMeta
}
